import { BreakoutTaskEditorDescriptor, ProgramTask } from '@cibo/core'
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useProgramEngagementContext } from '../../../context'
import { TaskEditorComponentProps } from '../TaskEditorComponent/types'

type BreakoutTaskEditorProps = {
  display: BreakoutTaskEditorDescriptor
  task: ProgramTask
  TaskEditorComponent(props: TaskEditorComponentProps): ReactElement
}

export const BreakoutTaskEditor = ({
  display,
  task,
  TaskEditorComponent,
}: BreakoutTaskEditorProps) => {
  const { t } = useTranslation('@cibo/programs/BreakoutTaskEditor')
  const { refreshEngagement } = useProgramEngagementContext()
  const [open, setOpen] = useState(false)

  const { breakoutCta, hideTitles, buttonProps } = display.params

  const handleClose = () => {
    refreshEngagement()
    setOpen(false)
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        data-testid="breakout-task-editor-cta"
        onClick={() => setOpen(true)}
        {...(buttonProps as any)}
      >
        {breakoutCta}
      </Button>

      <Dialog open={open} onClose={handleClose} fullScreen>
        <DialogTitle
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          {breakoutCta}
          <IconButton
            aria-label={t('close', { defaultValue: 'Close' })}
            data-testid="breakout-task-editor-close"
            onClick={handleClose}
            edge="end"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ overflowX: 'auto' }}>
          <Box data-testid="breakout-task-editor-dialog" sx={{ pt: 1 }}>
            <TaskEditorComponent task={task} params={{ hideTitles }} />
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="contained"
            color="primary"
            data-testid="breakout-task-editor-done"
            onClick={handleClose}
          >
            {t('done', { defaultValue: 'Done' })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
